module.exports = __webpack_public_path__ + "static/media/loading.f2a51d89.gif";